"use client";

import { isLiveMode } from "@/lib/mudwater-mode";
import { DemoWalletProvider } from "@/lib/wallet/DemoWalletProvider";
import { LiveWalletProvider } from "@/lib/wallet/LiveWalletProvider";

import type { ReactNode } from "react";

// Consumers and test fixtures import the context from here; keep these
// re-exports so moving the implementation stays invisible to them.
export { WalletContext } from "@/lib/wallet/context";
export type { WalletState } from "@/lib/wallet/context";

/** Build-time split, matching Claim, RipPacks and the inventory hooks. */
export function WalletProvider({
  children,
  returning,
}: {
  children: ReactNode;
  /** The returning-holder cookie, read by the root layout. */
  returning?: boolean;
}) {
  return isLiveMode() ? (
    <LiveWalletProvider returning={returning}>{children}</LiveWalletProvider>
  ) : (
    <DemoWalletProvider>{children}</DemoWalletProvider>
  );
}
